import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Settings from "src/components/icons/Settings";
import { CreditAppStatuses } from "Types/creditApp";
import StepCard from "../StepCard";
import CreditApproved from "./states/CreditApproved";
import CreditDisabled from "./states/CreditDisabled";
import CreditOrSkip from "./states/CreditOrSkip";
import CreditSkipped from "./states/CreditSkipped";
import CreditAppSubmitted from "./states/CreditSubmitted";
import "./StepOne.scss";

export interface StepOneProps {
    active?: boolean;
    className?: string;
    status?: CreditAppStatuses;
    [k: string]: any;
}

const StepOne: FunctionComponent<StepOneProps & WithTranslation> = ({
    active,
    className,

    status,
    onSkipForNow,
    onGoToCreditApp,
    t,
}) => {
    const done = !active && status !== undefined;
    const renderContent = () => {
        if (done) {
            switch (status) {
                case "skipped":
                    return <CreditSkipped onGoToCreditApp={onGoToCreditApp} />;
                case "approved":
                    return <CreditApproved />;
                case "disabled":
                    return <CreditDisabled />;
                default:
                    return <CreditAppSubmitted />;
            }
        }

        return <CreditOrSkip onSkipForNow={onSkipForNow} onGoToCreditApp={onGoToCreditApp} />;
    };

    return (
        <StepCard active={active || !done} className={classNames("StepOne", className)} done={done} icon={Settings}>
            <span className="StepOne__step-name">{t("ContinueDeal.StepOne.title")}</span>
            {renderContent()}
        </StepCard>
    );
};

export default withTranslation()(StepOne);
